import {ClientInfo} from "./clientInfo.model";
import {PartItemArray} from "../partItemArray.model";

export class SvedClientType extends PartItemArray{
  clientInfo: ClientInfo = new ClientInfo();
}
